import React, { useState } from 'react';
import { Search } from 'lucide-react';
import DestinationField from './fields/DestinationField';
import DateRangeField from './fields/DateRangeField';
import ParticipantField from './fields/ParticipantField';
import { Form, Formik } from 'formik';
import dayjs from 'dayjs';

const SearchBarComponent = ({ traits }) => {
    const {
        hideCalendarField,
        hideDestinationField,
        hideParticipantField,
    } = traits;

    const filterConfiguration = [];
    const filters = [];

    const [isDateSelectorOpen, setIsDateSelectorOpen] = useState(false);
    const [showParticipantSelector, setShowParticipantSelector] = useState(
        false
    );


    return (
        <div className="relative w-full">
            <Formik
                initialValues={{
                    destination: '',
                    startDate: {
                        date: {
                            startDate: dayjs().toDate(),
                            endDate: dayjs().toDate(),
                            key: 'selection',
                        },
                    },
                    participant: {
                        adults: 2,
                        children: 0,
                        extras: { dog: false, barrier: false, babyBed: false },
                    },
                }}
                onSubmit={()=>{}}
            >
                <Form>
                    <div className="w-full  mx-auto relative ">
                        <div className="flex flex-col lg:flex-row items-center gap-2 lg:gap-0">
                            {/* Destination input */}
                            {!hideDestinationField && <DestinationField name="destination" />}

                            {/* Date range */}
                            {!hideCalendarField && (
                                <DateRangeField
                                    name="startDate"
                                    isDateSelectorOpen={isDateSelectorOpen}
                                    setIsDateSelectorOpen={
                                        setIsDateSelectorOpen
                                    }
                                />
                            )}

                            {/* Guests - clickable to show participant selector */}
                            {!hideParticipantField && <ParticipantField
                                onClick={() =>
                                    setShowParticipantSelector(
                                        !showParticipantSelector
                                    )
                                }
                                showParticipantSelector={
                                    showParticipantSelector
                                }
                                name="participant"
                            />}

                            {/* Search button */}
                            <button
                                // onClick={handleSearch}
                                type="submit"
                                className="flex-shrink-0 px-8 py-4 bg-[#c45453] flex items-center justify-center  rounded-full lg:rounded-l-none lg:rounded-r-full"
                            >
                                <Search className="text-white mr-2" size={20} />
                                <span className="text-white font-medium">
                                    Urlaub finden
                                </span>
                            </button>
                        </div>
                    </div>
                </Form>
            </Formik>
        </div>
    );
};

export default SearchBarComponent;
